import React, { Component } from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

class Process extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
                <div className="fondrt-process">
                    <div className="fondrt-process__top">
                        <div className="fondrt-process__title">Процесс</div>
                        <div className="fondrt-process__text">
                            Когда мы принимаем проект, проводим его аудит и формируем перечень
                            элементов в публичной и серверной части сервиса, реализацию которых
                            необходимо оптимизировать или усовершенствовать.
                            <div>
                                Далее все изменения и доработки согласовываются с клиентом и
                                составляется план работ.
                            </div>
                            За два месяца работы над сайтом внесли ряд усовершенствований, что
                            существенно уменьшило количество ошибок в сценариях работы личного
                            кабинета дольщика и иных функциональных модулях, обозначенных заказчиком
                            и выявленных в ходе первичного аудита.
                        </div>
                    </div>

                    <div className="fondrt-process__bottom">
                        <div className="fondrt-process__subtitle">Что сделали:</div>

                        <div className="fondrt-process__wrapper">
                            <div className="fondrt-process__container">
                                <div className="fondrt-process__col1">
                                    <div className="fondrt-process__card">
                                        <div className="fondrt-process__number">01.</div>

                                        <div className="fondrt-process__inner">
                                            <div className="fondrt-process__name">
                                                Добавили валидацию полей
                                            </div>
                                            <div className="fondrt-process__text">
                                                Проверка корректности данных и их интеграция в
                                                систему происходит онлайн. Количество технических
                                                ошибок свелось к нулю.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="fondrt-process__card">
                                        <div className="fondrt-process__number">02.</div>

                                        <div className="fondrt-process__inner">
                                            <div className="fondrt-process__name">
                                                Внедрили новый функционал
                                            </div>
                                            <div className="fondrt-process__text">
                                                В форму заявления на компенсацию добавили критически
                                                важный функционал. Теперь родитель может оформить
                                                заявку на долю ребенка, что ранее было недоступно.
                                                Также нерезиденты РФ получили возможность подать
                                                заявку на возмещение через сайт.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="fondrt-process__card">
                                        <div className="fondrt-process__number">03.</div>

                                        <div className="fondrt-process__inner">
                                            <div className="fondrt-process__name">
                                                Настроили автозаполнение полей
                                            </div>
                                            <div className="fondrt-process__text">
                                                Пользователю нужно ввести название банка или БИК,
                                                заполнение остальных реквизитов происходит
                                                автоматически.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="fondrt-process__col2">
                                    <div className="fondrt-process__card">
                                        <div className="fondrt-process__number">04.</div>

                                        <div className="fondrt-process__inner">
                                            <div className="fondrt-process__name">
                                                Оптимизировали сценарии
                                            </div>
                                            <div className="fondrt-process__text">
                                                Провели много точечных доработок для дополнения
                                                функционала и развития проекта. Работали на PHP
                                                стеке.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="fondrt-process__card">
                                        <div className="fondrt-process__number">05.</div>

                                        <div className="fondrt-process__inner">
                                            <div className="fondrt-process__name">
                                                Сделали рефакторинг сайта
                                            </div>
                                            <div className="fondrt-process__text">
                                                Для устойчивости сайта к нагрузкам улучшили
                                                производительность и безопасность, закрыли некоторые
                                                роуты. Перешли на универсальные системы, чтобы в
                                                дальнейшем клиенту было удобнее и дешевле
                                                поддерживать функционирование проекта.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="fondrt-process__card">
                                        <div className="fondrt-process__number">06.</div>

                                        <div className="fondrt-process__inner">
                                            <div className="fondrt-process__name">
                                                Интегрировали с ЕСИА.
                                            </div>
                                            <div className="fondrt-process__text">
                                                Теперь пользователь может авторизоваться через
                                                аккаунт на портале Госуслуги.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="fondrt-process__footer">
                        <img
                            src="/images/pic/fondrt/monitor.png"
                            alt=""
                            loading="lazy"
                            className="fondrt-process__image"
                        />
                    </div>
                </div>
            </ScrollAnimation>
        );
    }
}

export default Process;
